// extracted by mini-css-extract-plugin
export var avatar = "_pp-3";
export var avatarContainer = "_pp-2";
export var avatarSpacer = "_pp-5";
export var avatarSpacerContainer = "_pp-4";
export var avatarStackContainer = "_pp-1";
export var bubble = "_pp-0";
export var remainderBubble = "_pp-6";